import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
}: SEOMetaProps) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;

    const setMeta = (name: string, content: string, propName?: string) => {
      let el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        if (propName) {
          el.setAttribute('property', name);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', ogTitle || title, 'property');
    setMeta('og:description', ogDescription || description, 'property');
    setMeta('og:type', ogType, 'property');
    setMeta('og:url', canonicalUrl, 'property');
    if (ogImage) {
      setMeta('og:image', ogImage, 'property');
    }
    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl);
    }

    return () => {
      document.title = originalTitle;
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogImage, ogType]);

  return null;
}